module.exports = __webpack_public_path__ + "515b9ba687a120cceafd7518f026c02f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/url-placeholder.png
// module id = 2942
// module chunks = 0